import { useEffect, useState } from 'react'
import { ref, onValue, off } from 'firebase/database'
import { db } from '../firebase'

const BounceLeaderboard = ({ players }) => {
  const [usernames, setUsernames] = useState({})

  // Fetch usernames for all players
  useEffect(() => {
    if (!players || Object.keys(players).length === 0) {
      return
    }

    const uids = Object.keys(players)
    const unsubscribes = []

    uids.forEach(uid => {
      const userRef = ref(db, `profiles/${uid}/userName`)
      const unsubscribe = onValue(userRef, (snapshot) => {
        const username = snapshot.val()
        setUsernames(prev => ({
          ...prev,
          [uid]: username || `User ${uid.substring(0, 8)}`
        }))
      })
      unsubscribes.push(() => off(userRef))
    })

    return () => {
      unsubscribes.forEach(unsub => unsub())
    }
  }, [players])

  if (!players || Object.keys(players).length === 0) {
    return (
      <div style={{ marginLeft: '20px', padding: '10px', border: '1px solid #ccc' }}>
        <h3>Leaderboard</h3>
        <p>No players yet</p>
      </div>
    )
  }

  // Convert players object to array and sort by score descending
  const leaderboardEntries = Object.entries(players).map(([uid, playerData]) => ({
    uid,
    color: playerData[2],
    score: playerData[3] || 0,
    position: [playerData[0], playerData[1]],
    username: usernames[uid] || 'Loading...'
  }))

  // Sort by score descending
  leaderboardEntries.sort((a, b) => b.score - a.score)

  return (
    <div style={{ 
      marginLeft: '20px', 
      padding: '15px', 
      border: '2px solid #333',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      minWidth: '250px'
    }}>
      <h3 style={{ marginTop: 0, marginBottom: '15px', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
        🏆 Leaderboard
      </h3>
      <div>
        {leaderboardEntries.map((entry, index) => (
          <div 
            key={entry.uid}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px',
              marginBottom: '5px',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontWeight: 'bold', minWidth: '20px' }}>#{index + 1}</span>
              <div 
                style={{ 
                  width: '20px', 
                  height: '20px', 
                  backgroundColor: entry.color,
                  border: '1px solid black',
                  borderRadius: '3px'
                }} 
              />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>
                {entry.username}
              </span>
            </div>
            <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
              {entry.score} pts
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BounceLeaderboard
